"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const IconContainer_1 = __importStar(require("../IconContainer"));
const CheckIcon = ({ size = IconContainer_1.DEFAULT_ICON_SIZE, ...rest }) => ((0, jsx_runtime_1.jsxs)(IconContainer_1.StyledSvg, { fill: "none", height: size, viewBox: "0 0 24 24", width: size, xmlns: "http://www.w3.org/2000/svg", ...rest, children: [(0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M12 22H2V12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z", fillRule: "evenodd" }), (0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M12.138 10.34a3.005 3.005 0 012.998 2.997c0 1.665-1.372 2.992-2.998 2.992a2.994 2.994 0 01-2.995-2.994V7.048h.746c.411 0 .747.38.747.845l-.002 2.853a2.98 2.98 0 011.504-.405zm0 4.507a1.512 1.512 0 100-3.023 1.512 1.512 0 000 3.023z", fill: "#fff", fillRule: "evenodd" })] }));
exports.default = (0, IconContainer_1.default)(CheckIcon);
//# sourceMappingURL=index.js.map